import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import user from './modules/user'
import search from './modules/search'
import socket from './modules/socket'
import video from './modules/video'
import audio from './modules/audio'
import intercom from './modules/intercom'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user, search, socket, video, audio, intercom
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js